import { types } from 'mobx-state-tree';

import MobileNavigationTab, {
  MobileNavigationTabType,
} from '../../types/MobileNavigationTab';
import { blockScroll, unblockScroll } from '../../util/dom';
import Modal from './Modal';

const MobileNavigation = Modal.named('MobileNavigation')
  .props({
    mobileMenuHeight: types.maybeNull(types.number),
    activeTab: types.optional(
      MobileNavigationTabType,
      MobileNavigationTab.PRODUCTS
    ),
    // Blocks hamburger / outside-click / close while Regional Settings Save
    // is in flight so a failed request can still surface its error.
    closeBlocked: types.optional(types.boolean, false),
  })
  .actions((self) => {
    return {
      updateMenuHeight(height) {
        self.mobileMenuHeight = height;
      },
      selectTab(tab) {
        if (self.closeBlocked) {
          return;
        }
        self.activeTab = tab;
      },
      setCloseBlocked(blocked) {
        self.closeBlocked = Boolean(blocked);
      },
      close() {
        if (self.closeBlocked) {
          return;
        }
        self.isOpen = false;
        unblockScroll();
      },
      open() {
        self.isOpen = true;
        blockScroll();
      },
      toggle(useBlockScroll = true, state = null) {
        const nextIsOpen = state == null ? !self.isOpen : Boolean(state);
        if (self.closeBlocked && self.isOpen && !nextIsOpen) {
          return;
        }
        self.isOpen = nextIsOpen;
        if (useBlockScroll) {
          if (self.isOpen) {
            blockScroll();
          } else {
            unblockScroll();
          }
        }
      },
    };
  });

export default MobileNavigation;
